<p *ngIf="langue.l == 'fr'">
    Pour causer des hallucinations à une personne :
</p>
<p *ngIf="langue.l == 'en'">
    To cause someone to hallucinate :
</p>
